// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';
// import { BiBuilding } from 'react-icons/bi';
// import { API_BASE_URL } from '../utils/urls.js';

// const OrganizationView = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [organization, setOrganization] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [users, setUsers] = useState([]);
//   const [error, setError] = useState(null);

//   const fetchOrganization = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${API_BASE_URL}/organizations/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setOrganization(response.data);
//       console.log('Organization data:', response.data);

//       const usersResponse = await axios.get(`${API_BASE_URL}/organizations/${id}/users`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setUsers(usersResponse.data);
//     } catch (err) {
//       setError('Failed to fetch organization details.');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrganization();
//   }, [id]);

//   if (loading)
//     return <div className="text-center text-gray-500 py-10">Loading organization...</div>;
//   if (error)
//     return <div className="text-center text-red-500 py-10">{error}</div>;
//   if (!organization)
//     return <div className="text-center text-gray-500 py-10">No organization data found.</div>;

//   return (
//     <div className="container mx-auto p-4 sm:p-6 max-w-4xl">
//       <div className="bg-white shadow-lg rounded-lg p-4 sm:p-6">
//         {/* Header Section */}
//         <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 mb-6">
//           <BiBuilding className="w-16 h-16 text-blue-500 flex-shrink-0" />
//           <div className="text-center sm:text-left">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">{organization.name}</h1>
//             <p className="text-gray-600 capitalize">{organization.plan_type} Plan</p>
//           </div>
//         </div>

//         {/* Organization Details */}
//         <div className="border-t border-gray-200 pt-4">
//           <dl className="divide-y divide-gray-200">
//             {[
//               { label: 'Admin Name', value: organization.admin_user_name },
//               { label: 'Admin Email', value: organization.admin_user_email },
//               { label: 'Plan Type', value: organization.plan_type },
//               { label: 'Active Cases Limit', value: organization.active_cases_limit || 'Unlimited' },
//               { label: 'User Limit', value: organization.user_limit || 'Unlimited' },
//               { label: 'Billing Status', value: organization.billing_status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())},
//               { label: 'Trial/Service Ends At', value: organization.subscription_ends_at ? new Date(organization.trial_ends_at).toLocaleDateString() : 'N/A' },
//               { label: 'Billing Interval', value: organization.billing_interval ? organization.billing_interval.toUpperCase() : 'N/A' },
//               { label: 'Registered At', value: organization.created_at ? new Date(organization.created_at).toLocaleDateString() : 'N/A' },
//             ].map((item) => (
//               <div
//                 key={item.label}
//                 className="py-3 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4"
//               >
//                 <dt className="text-sm font-medium text-gray-500">{item.label}</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 capitalize break-words">
//                   {item.value || 'N/A'}
//                 </dd>
//               </div>
//             ))}
//           </dl>
//         </div>

//         {/* Users Section */}
//         <div className="mt-8">
//           <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Users</h2>

//           {/* Desktop Table */}
//           <div className="hidden md:block overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-3 sm:px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Name
//                   </th>
//                   <th className="px-3 sm:px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Email
//                   </th>
//                   <th className="px-3 sm:px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Role
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {users.length > 0 ? (
//                   users.map((user) => (
//                     <tr
//                       key={user.id}
//                       className="hover:bg-gray-50 transition-colors duration-200"
//                     >
//                       <td className="px-3 sm:px-6 py-2 whitespace-nowrap text-sm font-medium text-blue-600 hover:underline">
//                         <Link
//                           to={`/super-admin/users/${user.id}`}
//                           className="text-blue-600 hover:text-blue-800"
//                         >
//                           {user.first_name} {user.last_name}
//                         </Link>
//                       </td>
//                       <td className="px-3 sm:px-6 py-2 whitespace-nowrap text-sm text-gray-500">
//                         {user.email}
//                       </td>
//                       <td className="px-3 sm:px-6 py-2 whitespace-nowrap text-sm text-gray-500 capitalize">
//                         {user.role_name.replace('_', ' ')}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="3"
//                       className="px-3 sm:px-6 py-4 text-center text-sm text-gray-500"
//                     >
//                       No users found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Mobile Card View */}
//           <div className="block md:hidden space-y-4">
//             {users.length > 0 ? (
//               users.map((user) => (
//                 <div
//                   key={user.id}
//                   className="border border-gray-200 rounded-lg p-4 bg-gray-50 shadow-sm"
//                 >
//                   <div className="flex justify-between items-center">
//                     <Link
//                       to={`/super-admin/users/${user.id}`}
//                       className="font-semibold text-blue-600 text-base"
//                     >
//                       {user.first_name} {user.last_name}
//                     </Link>
//                     <span className="text-xs text-gray-500 capitalize">
//                       {user.role_name.replace('_', ' ')}
//                     </span>
//                   </div>
//                   <p className="text-sm text-gray-600 mt-1 break-words">{user.email}</p>
//                 </div>
//               ))
//             ) : (
//               <p className="text-center text-gray-500 py-3">No users found.</p>
//             )}
//           </div>
//         </div>

//         {/* Back Button */}
//         <div className="mt-8 text-center">
//           <Link
//             to="/organizations"
//             className="inline-block px-5 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition text-sm sm:text-base"
//           >
//             ← Back to Organizations
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrganizationView;


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { BiBuilding, BiImageAlt } from 'react-icons/bi';
import { API_BASE_URL } from '../utils/urls.js';

const OrganizationView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [imageError, setImageError] = useState(false); // Track if image fails to load

  const fetchOrganization = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/organizations/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrganization(response.data);

      const usersResponse = await axios.get(`${API_BASE_URL}/organizations/${id}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(usersResponse.data);
    } catch (err) {
      setError('Failed to fetch organization details.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganization();
  }, [id]);

  if (loading) return <div className="text-center text-gray-500 py-10">Loading organization...</div>;
  if (error) return <div className="text-center text-red-500 py-10">{error}</div>;
  if (!organization) return <div className="text-center text-gray-500 py-10">No organization data found.</div>;

  // Safer URL constructor: Splits at '/api' to guarantee we just get the domain/port
  const getLogoUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path; // If it's already a full URL, return it
    
    // Example: changes "http://localhost:5000/api" -> "http://localhost:5000"
    const baseUrl = API_BASE_URL.split('/api')[0]; 
    return `${baseUrl}${path}`;
  };

  return (
    <div className="container mx-auto p-4 sm:p-6 max-w-4xl">
      <div className="bg-white shadow-lg rounded-lg p-4 sm:p-6">
        
        {/* Header Section with Dynamic Logo */}
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 mb-6">
          
          {/* Logo Display Logic */}
          {organization.logo_url && !imageError ? (
             <img 
               src={getLogoUrl(organization.logo_url)} 
               alt={`${organization.name} Logo`} 
               className="w-16 h-16 object-contain flex-shrink-0 border rounded p-1 bg-white shadow-sm"
               onError={() => {
                 console.error("Failed to load image at:", getLogoUrl(organization.logo_url));
                 setImageError(true); // Switches to fallback icon if image is broken
               }}
             />
          ) : (
            <div className="w-16 h-16 bg-blue-50 text-blue-500 rounded flex items-center justify-center flex-shrink-0 border">
                {imageError ? <BiImageAlt className="w-8 h-8 opacity-50" title="Broken Image Link"/> : <BiBuilding className="w-10 h-10" />}
            </div>
          )}

          <div className="text-center sm:text-left mt-2 sm:mt-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">{organization.name}</h1>
            <p className="text-gray-600 capitalize">{organization.plan_type} Plan</p>
          </div>
        </div>

        {/* Organization Details */}
        <div className="border-t border-gray-200 pt-4">
          <dl className="divide-y divide-gray-200">
            {[
              { label: 'Admin Name', value: organization.admin_user_name },
              { label: 'Admin Email', value: organization.admin_user_email },
              { label: 'Plan Type', value: organization.plan_type },
              { label: 'Active Cases Limit', value: organization.active_cases_limit || 'Unlimited' },
              { label: 'User Limit', value: organization.user_limit || 'Unlimited' },
              { label: 'Billing Status', value: organization.billing_status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())},
              { label: 'Trial/Service Ends At', value: organization.subscription_ends_at ? new Date(organization.trial_ends_at).toLocaleDateString() : 'N/A' },
              { label: 'Billing Interval', value: organization.billing_interval ? organization.billing_interval.toUpperCase() : 'N/A' },
              { label: 'Registered At', value: organization.created_at ? new Date(organization.created_at).toLocaleDateString() : 'N/A' },
            ].map((item) => (
              <div key={item.label} className="py-3 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4">
                <dt className="text-sm font-medium text-gray-500">{item.label}</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 capitalize break-words">
                  {item.value || 'N/A'}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* Users Section (UNCHANGED) */}
        <div className="mt-8">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Users</h2>
          
          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 sm:px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                  <th className="px-3 sm:px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                  <th className="px-3 sm:px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {users.length > 0 ? (
                  users.map((user) => (
                    <tr key={user.id} className="hover:bg-gray-50 transition-colors duration-200">
                      <td className="px-3 sm:px-6 py-2 whitespace-nowrap text-sm font-medium text-blue-600 hover:underline">
                        <Link to={`/super-admin/users/${user.id}`} className="text-blue-600 hover:text-blue-800">
                          {user.first_name} {user.last_name}
                        </Link>
                      </td>
                      <td className="px-3 sm:px-6 py-2 whitespace-nowrap text-sm text-gray-500">{user.email}</td>
                      <td className="px-3 sm:px-6 py-2 whitespace-nowrap text-sm text-gray-500 capitalize">{user.role_name.replace('_', ' ')}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="3" className="px-3 sm:px-6 py-4 text-center text-sm text-gray-500">No users found.</td></tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="block md:hidden space-y-4">
            {users.length > 0 ? (
              users.map((user) => (
                <div key={user.id} className="border border-gray-200 rounded-lg p-4 bg-gray-50 shadow-sm">
                  <div className="flex justify-between items-center">
                    <Link to={`/super-admin/users/${user.id}`} className="font-semibold text-blue-600 text-base">
                      {user.first_name} {user.last_name}
                    </Link>
                    <span className="text-xs text-gray-500 capitalize">{user.role_name.replace('_', ' ')}</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1 break-words">{user.email}</p>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500 py-3">No users found.</p>
            )}
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <Link to="/organizations" className="inline-block px-5 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition text-sm sm:text-base">
            ← Back to Organizations
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrganizationView;